import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PublicOffer.css';

const PublicOffer: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="public-offer">
      <button onClick={handleBackClick} className="back-link">
        ← Вернуться на главную
      </button>
      
      <h1>Публичная оферта</h1>
      
      <p><strong>Дата последнего обновления:</strong> 15 января 2025 года</p>
      
      <h2>1. Общие положения</h2>
      <p>Настоящая публичная оферта (далее — «Оферта») является официальным предложением ООО «ДИСАЙ» (далее — «Исполнитель», «Компания») заключить договор на оказание информационных услуг через сервис Dissai (далее — «Сервис») на условиях, изложенных ниже.</p>
      
      <p>Акцепт (принятие) настоящей Оферты осуществляется путем регистрации в Сервисе и/или оплаты услуг. Момент акцепта считается моментом заключения Договора.</p>
      
      <h2>2. Предмет договора</h2>
      <p>Исполнитель обязуется предоставить Заказчику доступ к Сервису для создания персонализированных контент-планов с использованием технологий искусственного интеллекта, а Заказчик обязуется оплатить услуги в соответствии с выбранным тарифным планом.</p>
      
      <h3>2.1. Услуги включают:</h3>
      <ul>
        <li>Анализ целевой аудитории на основе предоставленных данных</li>
        <li>Анализ успешных публикаций в социальных сетях</li>
        <li>Создание персонализированных контент-планов</li>
        <li>Генерацию roadmap для развития аккаунта</li>
        <li>Предоставление инструментов для редактирования контента</li>
        <li>Техническую поддержку пользователей</li>
      </ul>
      
      <h2>3. Стоимость услуг и порядок оплаты</h2>
      
      <table className="price-table">
        <thead>
          <tr>
            <th>Тарифный план</th>
            <th>Стоимость</th>
            <th>Период</th>
          </tr>
        </thead>
        <tbody>
        <tr>
            <td>Эксперт</td>
            <td>2500 рублей</td>
            <td>1 месяц</td>
          </tr>
          <tr>
            <td>Pro</td>
            <td>5 000 рублей</td>
            <td>1 месяц</td>
          </tr>
          <tr>
            <td>Команда</td>
            <td>15 000 рублей</td>
            <td>1 месяц</td>
          </tr>
        </tbody>
      </table>
      
      <h3>3.1. Условия оплаты:</h3>
      <ul>
        <li>Оплата производится в российских рублях</li>
        <li>Доступны способы оплаты: банковские карты, электронные кошельки</li>
        <li>Подписка продлевается автоматически</li>
        <li>Первые 3 дня тарифа Pro предоставляются бесплатно</li>
        <li>НДС не облагается (УСН)</li>
      </ul>
      
      <h3>3.2. Изменение стоимости:</h3>
      <p>Исполнитель оставляет за собой право изменять стоимость услуг с уведомлением Заказчика не менее чем за 30 дней до вступления изменений в силу.</p>
      
      <h2>4. Права и обязанности сторон</h2>
      
      <h3>4.1. Исполнитель обязуется:</h3>
      <ul>
        <li>Предоставить доступ к Сервису в соответствии с выбранным тарифом</li>
        <li>Обеспечить работоспособность Сервиса 99% времени в месяц</li>
        <li>Предоставлять техническую поддержку</li>
        <li>Обеспечивать конфиденциальность данных Заказчика</li>
        <li>Уведомлять о плановых технических работах</li>
      </ul>
      
      <h3>4.2. Исполнитель имеет право:</h3>
      <ul>
        <li>Приостановить доступ при нарушении условий использования</li>
        <li>Изменять функциональность Сервиса для его улучшения</li>
        <li>Устанавливать лимиты использования в рамках тарифных планов</li>
        <li>Требовать соблюдения правил использования Сервиса</li>
      </ul>
      
      <h3>4.3. Заказчик обязуется:</h3>
      <ul>
        <li>Своевременно оплачивать услуги</li>
        <li>Предоставлять достоверную информацию при регистрации</li>
        <li>Соблюдать правила использования Сервиса</li>
        <li>Не нарушать права третьих лиц</li>
        <li>Уведомлять о несанкционированном доступе к аккаунту</li>
      </ul>
      
      <h3>4.4. Заказчик имеет право:</h3>
      <ul>
        <li>Использовать Сервис в рамках выбранного тарифа</li>
        <li>Получать техническую поддержку</li>
        <li>Отменить подписку в любое время</li>
        <li>Требовать возврата средств в установленных случаях</li>
      </ul>
      
      <h2>5. Порядок предоставления услуг</h2>
      <h3>5.1. Активация услуг:</h3>
      <ul>
        <li>Доступ предоставляется немедленно после успешной оплаты</li>
        <li>Для тарифа Pro доступен 3-дневный пробный период</li>
        <li>Активация происходит автоматически</li>
      </ul>
      
      <h3>5.2. Техническая поддержка:</h3>
      <ul>
        <li>Время ответа: в рабочие дни до 24 часов</li>
        <li>Способы обращения: email support@dissai.ru</li>
        <li>Язык поддержки: русский</li>
      </ul>
      
      <h2>6. Ответственность сторон</h2>
      
      <div className="important">
        <p><strong>Важно:</strong> Исполнитель не несет ответственности за результаты использования созданного контента в социальных сетях.</p>
      </div>
      
      <h3>6.1. Ограничение ответственности:</h3>
      <ul>
        <li>Максимальная ответственность Исполнителя ограничена стоимостью услуг за последний оплаченный период</li>
        <li>Исполнитель не отвечает за упущенную выгоду</li>
        <li>Не гарантируется достижение конкретных результатов в социальных сетях</li>
      </ul>
      
      <h3>6.2. Форс-мажор:</h3>
      <p>Стороны освобождаются от ответственности при наступлении обстоятельств непреодолимой силы.</p>
      
      <h2>7. Возврат денежных средств</h2>
      <h3>7.1. Право на отказ от услуг</h3>
      <p>В соответствии со ст. 32 Закона РФ «О защите прав потребителей», Заказчик вправе отказаться от Услуг Исполнителя в любое время. Для этого Заказчику необходимо направить уведомление об отказе на электронный адрес legal@dissai.ru.</p>
      
      <h3>7.2. Расчет суммы возврата</h3>
      <p>В случае досрочного отказа Заказчика от Услуг, Исполнитель производит возврат денежных средств за неиспользованный период подписки. Сумма возврата рассчитывается пропорционально количеству оставшихся дней в оплаченном периоде.</p>
      
      <h3>7.3. Удержание фактических расходов</h3>
      <p>Исполнитель вправе удержать из суммы возврата стоимость фактически понесенных расходов, связанных с исполнением обязательств по настоящему договору.</p>
      
      <h3>7.4. Ограничения возврата</h3>
      <ul>
        <li>Возврат денежных средств не производится за период, в котором услуги уже были оказаны</li>
        <li>Возврат не производится за использованный пробный период</li>
        <li>Возврат осуществляется на тот же расчетный счет или банковскую карту, с которых производилась оплата</li>
      </ul>
      
      <h3>7.5. Сроки возврата</h3>
      <p>Денежные средства возвращаются в течение 10 (десяти) банковских дней с момента получения Исполнителем уведомления об отказе.</p>
      
      <h2>8. Конфиденциальность</h2>
      <p>Исполнитель обязуется:</p>
      <ul>
        <li>Обеспечивать конфиденциальность персональных данных</li>
        <li>Не передавать данные третьим лицам без согласия</li>
        <li>Использовать данные только для предоставления услуг</li>
        <li>Соблюдать требования ФЗ «О персональных данных»</li>
      </ul>
      
      <p>Порядок сбора, хранения и обработки персональных данных Заказчика регулируется отдельным документом — Политикой конфиденциальности, размещенной по адресу <a href="/privacy-policy">https://dissai.io/privacy-policy</a> и являющейся неотъемлемой частью настоящего Соглашения.</p>
      
      <h2>9. Интеллектуальная собственность</h2>
      <h3>9.1. Права на Сервис:</h3>
      <p>Все права на программное обеспечение, дизайн и содержание Сервиса принадлежат Исполнителю.</p>
      
      <h3>9.2. Права на созданный контент:</h3>
      <p>Контент, созданный с помощью Сервиса на основе данных Заказчика, принадлежит Заказчику.</p>
      
      <h2>10. Расторжение договора</h2>
      <h3>10.1. По инициативе Заказчика:</h3>
      <ul>
        <li>Отмена подписки через интерфейс Сервиса</li>
        <li>Доступ сохраняется до окончания оплаченного периода</li>
        <li>Возможность повторной активации в любое время</li>
      </ul>
      
      <h3>10.2. По инициативе Исполнителя:</h3>
      <ul>
        <li>При нарушении условий договора</li>
        <li>При неоплате услуг в течение 7 дней</li>
        <li>С уведомлением за 30 дней при прекращении деятельности</li>
      </ul>
      
      <h2>11. Заключительные положения</h2>
      <h3>11.1. Изменение условий:</h3>
      <p>Исполнитель оставляет за собой право изменять условия Оферты с уведомлением Заказчиков не менее чем за 30 дней.</p>
      
      <h3>11.2. Применимое право:</h3>
      <p>Договор регулируется законодательством Российской Федерации.</p>
      
      <h3>11.3. Разрешение споров:</h3>
      <p>Споры разрешаются путем переговоров, а при их неуспехе — в судебном порядке по месту нахождения Исполнителя.</p>
      
      <h2>12. Реквизиты Исполнителя</h2>
      <div className="contact-info">
        <p><strong>ООО «ДИСАЙ»</strong></p>
        <p><strong>ОГРН:</strong> 1250500006283</p>
        <p><strong>ИНН:</strong> 0500031568</p>
        <p><strong>Адрес:</strong> 367000, Респ. Дагестан, г. Махачкала, ул. Абубакарова, д. 115, каб. 2 помещ. 2</p>
        <p><strong>Email:</strong> support@dissai.ru</p>
      </div>
      
      <p>Настоящая Оферта является официальным документом и имеет юридическую силу с момента размещения на сайте.</p>
      
      <p><strong>Генеральный директор ООО «ДИСАЙ»</strong></p>
      <p>_________________</p>
      <p><em>М.П.</em></p>
    </div>
  );
};

export default PublicOffer;